export const optionalToNullable = (value: string): string | null => {
  return value.trim() === '' ? null : value
}
